"use client";

import {
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
  MenuItem,
  Select,
  useTheme,
  useMediaQuery,
  OutlinedInput,
  ListSubheader,
  Checkbox,
  Grid,
  Autocomplete,
  TextField,
} from "@mui/material";
import { ResponsiveLine } from "@nivo/line";
import { useEffect, useRef, useState } from "react";
import Header from "../Header/Header";
import MultiSelectFilter from "./MultiSelect";
import NewsCard from "./NewsCard";
import "./Analytics.css";
import WorkspaceAnalytics from "./WorkSpaceAnalytics";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../Utils/AxoisClient";
import { useLocation } from "react-router-dom";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

/* ---------------- Chart Data ---------------- */
const lineData = [
  {
    id: "London - Los Angeles",
    color: "#2563eb",
    data: [
      { x: "Qtr1", y: 95 },
      { x: "Qtr2", y: 90 },
      { x: "Qtr3", y: 85 },
      { x: "Qtr4", y: 92 },
    ],
  },
  {
    id: "Mumbai - Los Angeles",
    color: "#14b8a6",
    data: [
      { x: "Qtr1", y: 85 },
      { x: "Qtr2", y: 88 },
      { x: "Qtr3", y: 82 },
      { x: "Qtr4", y: 86 },
    ],
  },
  {
    id: "Hamburg - Los Angeles",
    color: "#a855f7",
    data: [
      { x: "Qtr1", y: 105 },
      { x: "Qtr2", y: 110 },
      { x: "Qtr3", y: 90 },
      { x: "Qtr4", y: 104 },
    ],
  },
];

const normalize = (val) => {
  if (!val) return [];

  if (Array.isArray(val)) {
    return Array.from(
      new Set(
        val.flatMap((v) =>
          typeof v === "string" ? v.split(",").map((s) => s.trim()) : [],
        ),
      ),
    );
  }

  if (typeof val === "string") {
    return val.split(",").map((s) => s.trim());
  }

  return [];
};

export default function MarketIntelligence() {
  const [tab, setTab] = useState({
    tabIndex: 0,
    tabName: "Ocean Freight",
    tabList: [
      {
        // name: "Origin Country",
        name: "Destination Country",
        multiSelect: false,
      },
      {
        // name: "Origin Port",
        name: "Destination Port",
        multiSelect: false,
      },
      {
        name: "Origin Country",
        // name: "Destination Country",
        multiSelect: true,
      },
      {
        // name: "Destination Port",
        name: "Origin Port",
        multiSelect: true,
      },
    ],
  });

  const currentTab = {
    0: "Ocean Freight",
    1: "Tariff",
    2: "Fuels",
  };

  const tabUpdatedValue = {
    0: {
      tabIndex: 0,
      tabName: "Ocean Freight",
      tabList: [
        {
          name: "Destination Country",
          multiSelect: false,
        },
        {
          name: "Destination Port",
          multiSelect: false,
        },
        {
          name: "Origin Country",
          multiSelect: true,
        },
        {
          name: "Origin Port",
          multiSelect: true,
        },
      ],
    },
    1: {
      tabIndex: 1,
      tabName: "Tariff",
      tabList: [
        {
          name: "Category",
          multiSelect: false,
        },
        {
          name: "HS Code",
          multiSelect: false,
        },
        // {
        //   name: "Origin Country",
        //   multiSelect: true,
        // },
        {
          name: "Destination Country",
          multiSelect: false,
        },
        {
          name: "Origin Country",
          multiSelect: true,
        },
      ],
    },
    2: {
      tabIndex: 2,
      tabName: "Fuel",
      tabList: [
        {
          name: "Origin Country",
          multiSelect: false,
        },
        {
          name: "Origin Port",
          multiSelect: false,
        },
        {
          name: "Destination Country",
          multiSelect: true,
        },
        {
          name: "Destination Port",
          multiSelect: true,
        },
      ],
    },
  };

  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [thirdDropDown, setThirdDropDown] = useState(
    normalize(location?.state?.params?.origin_country),
  );
  const [secondDropDown, setSecondDropDown] = useState([
    location?.state?.params?.destination_port,
  ]);
  const [firstDropDown, setFirstDropDown] = useState([
    location?.state?.params?.destination_country,
  ]);
  const [firstDropDownData, setFirstDropDownData] = useState([]);
  const [secondDropDownData, setSecondDropDownData] = useState([]);
  const [forthDropDown, setForthDropDown] = useState(
    normalize(location?.state?.params?.origin_port),
  );
  const [thirdDropDownData, setThirdDropDownData] = useState([]);
  const [forthDropDownData, setForthDropDownData] = useState([]);
  const [oceanFreightData, setOceanFreightData] = useState([]);
  const [countryPortData, setCountryPortData] = useState([
    location?.state?.params?.origin_country_port,
  ]);
  const [selected, setSelected] = useState([]);
  const [fuel, setFuel] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [selectedLocationDetails, setSelectedLocationDetails] = useState([]);
  const [selectedFuel, setSelectedFuel] = useState("");
  const [data, setData] = useState([]);
  const [range, setRange] = useState("1M");
  // AbortController ref
  const abortControllerRef = useRef(null);

  const [chartMessage, setChartMessage] = useState(
    "Please Select Required Value",
  );
  const [newsList, setNewList] = useState([
    {
      id: 1,
      image:
        "https://www.shutterstock.com/image-photo/usa-flag-memorial-day-veterans-260nw-2409028059.jpg",

      date: "Sep 11, 2024",
      title: "The US will continue to negotiate with China",
    },
  ]);
  let secondDropdownAbort = null;

  const debounceRef = useRef(null);
  const debouncePortRef = useRef(null);
  const debounceOceanRef = useRef(null);
  const updateTab = (e, v) => {
    setTab(tabUpdatedValue[v]);
    setFirstDropDown([]);
    setSecondDropDown([]);
    setThirdDropDown([]);
    setForthDropDown([]);
    setOceanFreightData([]);
  };

  const fetchDataSubCategory = async (value) => {
    // Abort previous request if exists
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create new controller
    const controller = new AbortController();
    abortControllerRef.current = controller;

    const payload = { name: value || "" };

    try {
      const response = await axiosInstance.post(
        `company/subcategory-list?limit=500&page=1`,
        payload,
        {
          signal: controller.signal, // 👈 attach signal
        },
      );

      setFirstDropDownData(response?.data?.data || []);
    } catch (error) {
      // Ignore aborted requests
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
        return;
      }

      toast.error("Failed to fetch data 🎉", { autoClose: 2000 });
    }
  };

  const fetchHScode = async (selectedSubCategory) => {
    const payload = {
      subcategory_id: selectedSubCategory?.id || "",
    };

    try {
      const response = await axiosInstance.post(
        "company/hsncode-list?limit=400&page=1",
        payload,
        // { signal: controller.signal }
      );

      const data = response?.data?.data;
      //   .map((ele) => ele?.hsncode);
      setSecondDropDownData(data);
    } catch (error) {
      if (error.name !== "CanceledError") console.error(error);
    }
  };

  async function fetchOriginCountryAPI(payload) {
    const response = await axiosInstance.post(
      "company/analytics/origin-country",
      payload,
    );

    return response?.data?.data || [];
  }
  async function fetchOriginCountryPort(payload) {
    const response = await axiosInstance.post(
      "company/analytics/origin-port",
      payload,
    );

    return response?.data?.data || [];
  }

  useEffect(() => {
    if (
      thirdDropDown === null ||
      thirdDropDown.length < 1 ||
      tab.tabName !== "Ocean Freight"
    )
      return;
    const payload = {
      origin_country: thirdDropDown?.join(",") || "",
    };
    const fetchData = async () => {
      setForthDropDown([]);
      const res = await fetchOriginCountryPort(payload);
      const data = res || [];
      const mappedData = data.map((item) => item?.origin_port);
      setForthDropDownData(data);
    };
    fetchData();
  }, [thirdDropDown]);

  function mapOriginCountryData(data) {
    return data.map((item) => item.origin_country);
  }

  async function GetFirstDropDownData() {
    const isOceanFreight = tab?.tabName === "Ocean Freight";
    if (!isOceanFreight) {
      fetchDataSubCategory(); // optional reset
      return;
    }
    const payload = {
      type: "Ocean Freight",
      origin_country: "",
      subcategory_id: "",
      hsncode: "",
    };
    try {
      //   const rawData = await fetchOriginCountryAPI(payload);
      const rawData = await getDestination(payload);
      const data = rawData?.map((element) => element?.destination_country);
      const mappedData = mapOriginCountryData(rawData);
      setFirstDropDownData(data);
    } catch (error) {
      toast.error("Failed to fetch data 🎉", { autoClose: 2000 });
    }
  }

  async function GetSecondDropDownData(originCountries) {
    const currentTab = tab?.tabName === "Ocean Freight";
    if (!currentTab) {
      fetchHScode(firstDropDown ?? 0); // optional reset
      return;
    }
    if (originCountries?.length < 1) return;

    if (secondDropdownAbort) {
      secondDropdownAbort.abort();
    }
    secondDropdownAbort = new AbortController();
    const fetchData = async () => {
      const data = await getDestinationPort();
      const portList = data.map((ele) => ele.destination_port);
      setSecondDropDownData(portList);
    };
    fetchData();
  }

  useEffect(() => {
    GetFirstDropDownData();
  }, [tab]);

  useEffect(() => {
    GetSecondDropDownData(firstDropDown);
  }, [firstDropDown]);

  async function getDestination(payload) {
    // Clear previous debounce
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    return new Promise((resolve) => {
      debounceRef.current = setTimeout(async () => {
        try {
          const response = await axiosInstance.post(
            "company/analytics/destination-country",
            payload,
          );

          const data = response?.data?.data ?? [];
          resolve(data);
        } catch (error) {
          if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
            resolve([]);
            return;
          }

          toast.error("Failed to fetch data 🎉", { autoClose: 2000 });
          resolve([]);
        }
      }, 500);
    });
  }

  async function getDestinationPort() {
    if (debouncePortRef.current) {
      clearTimeout(debouncePortRef.current);
    }

    return new Promise((resolve) => {
      debouncePortRef.current = setTimeout(async () => {
        const payload = {
          destination_country: firstDropDown,
        };
        try {
          const response = await axiosInstance.post(
            "company/analytics/destination-port",
            payload,
          );
          const data = response?.data?.data ?? [];
          resolve(data);
        } catch (error) {
          if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
            resolve([]);
            return;
          }

          toast.error("Failed to fetch data 🎉", { autoClose: 2000 });
          resolve([]); // ✅ always resolve
        }
      }, 500);
    });
  }

  async function getThirdDropDownData() {
    if (tab.tabName === "Tariff") {
      if (!firstDropDown?.id || !secondDropDown?.hsncode) return;
      let payload1 = {
        type: "Tariff Progress",
        subcategory_id: firstDropDown?.id,
        hsncode: secondDropDown?.hsncode,
      };
      let payload = {
        type: "Tariff Progress",
        origin_country: "",
        subcategory_id: firstDropDown?.id,
        hsncode: secondDropDown?.hsncode,
      };
      //   const res = await fetchOriginCountryAPI(payload);
      //   const mappedData = mapOriginCountryData(res);
      //   setThirdDropDownData(mappedData);
      const res = await getDestination(payload);
      const data = res?.map((element) => element?.destination_country);
      //   setForthDropDownData(data);

      setThirdDropDownData(data);
    } else {
      let payload = {
        type: "Ocean Freight", // tariff ,fuels,ocean
        subcategory_id: "", // required for tariff
        hsncode: "", // required for tariff
        destination_country: firstDropDown,
      };
      const res = await fetchOriginCountryAPI(payload);

      const data = res?.map((element) => element?.origin_country);
      setThirdDropDownData(data);
    }
  }

  useEffect(() => {
    getThirdDropDownData();
  }, [firstDropDown, secondDropDown]);

  const prevFirstDropDownRef = useRef(null);

  useEffect(() => {
    if (prevFirstDropDownRef.current === null) {
      prevFirstDropDownRef.current = firstDropDown;
      return;
    }

    // ✅ Run only if value actually changed
    if (prevFirstDropDownRef.current !== firstDropDown) {
      setForthDropDownData([]);
      setSecondDropDownData([]);
      setThirdDropDownData([]);
      setSecondDropDown([]);
      setThirdDropDown([]);
      setForthDropDown([]);
      setOceanFreightData([]);
    }
    // 🔄 Update previous value
    prevFirstDropDownRef.current = firstDropDown;
  }, [firstDropDown]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getDestinationPort();
      const portList = data.map((ele) => ele.destination_port);
      setForthDropDownData(portList);
    };
    const getData = async (payload) => {
      const res = await fetchOriginCountryAPI(payload);
      const mappedData = mapOriginCountryData(res);
      setForthDropDown([]);
      setForthDropDownData(mappedData);
      //   const res = await getDestination(payload);
      //   const data = res?.map((element) => element?.destination_country);
      //   setForthDropDownData(data);
    };
    if (tab.tabName === "Tariff") {
      if (!firstDropDown?.id || !secondDropDown?.hsncode) return;
      let payload = {
        type: "Tariff Progress",
        // // origin_country: thirdDropDown?.join(","),
        subcategory_id: firstDropDown?.id,
        hsncode: secondDropDown?.hsncode,
        destination_country: thirdDropDown,
        // destination_port: secondDropDown,
      };
      getData(payload);
    } else {
      //   fetchData();
    }
  }, [firstDropDown, secondDropDown, thirdDropDown]);

  async function getOceanFreight() {
    if (debounceOceanRef.current) {
      clearTimeout(debounceOceanRef.current);
    }
    return new Promise((resolve) => {
      debounceOceanRef.current = setTimeout(async () => {
        let payload = {};
        if (tab?.tabName === "Tariff") {
          //   const countryList = thirdDropDown?.map((ele) => {
          //     return { origin_country: ele };
          //   });
          const countryList = forthDropDown?.map((ele) => {
            return { origin_country: ele };
          });
          payload = {
            subcategory_id: firstDropDown?.id,
            hsncode: secondDropDown?.hsncode,
            origin_country_port_array: countryList,
            // destination_country: forthDropDown,
            destination_country: thirdDropDown,
          };
        } else {
          const normalize = (arr) => (Array.isArray(arr[0]) ? arr[0] : arr);
          payload = {
            origin_country_port_array: normalize(countryPortData),
            destination_country: firstDropDown,
            destination_port: secondDropDown,
          };
        }
        let url = "";
        if (tab?.tabName === "Tariff") {
          url = "company/analytics/tariff-data";
        } else {
          url = "company/analytics/ocean-freight-data";
        }

        try {
          const response = await axiosInstance.post(url, payload);
          const data = response?.data?.data ?? [];
          resolve(data);
        } catch (error) {
          if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
            resolve([]);
            return;
          }
          toast.error("Failed to fetch data 🎉", { autoClose: 2000 });
          resolve([]); // ✅ always resolve
        }
      }, 500);
    });
  }

  useEffect(() => {
    const fetchData = async () => {
      if (forthDropDown?.length < 1) return;
      const data = await getOceanFreight();
      const oceanFreightData = data?.map((ele) => {
        // return { ...ele, id: ele?.name };

        return {
          ...ele,
          id:
            tab.tabName === "Ocean Freight"
              ? `${ele?.raw?.origin_port}-${ele?.raw?.destination_port}`
              : `${ele?.raw?.origin_country_name}-${ele?.raw?.destination_country_name}`,
        };
      });
      setOceanFreightData(oceanFreightData);
      if (oceanFreightData.length < 1) {
        setChartMessage("No Data Found");
      }
    };

    fetchData();
  }, [forthDropDown, tab]);

  const hasSinglePoint = oceanFreightData?.some(
    (serie) => serie.data.length === 1,
  );

  // Convert Nivo data format to Recharts format
  const convertToRechartsData = (nivoData) => {
    if (!nivoData || nivoData.length === 0) return [];

    const rechartsData = [];
    const quarterMap = {};

    nivoData.forEach((series) => {
      series.data.forEach((point) => {
        if (!quarterMap[point.x]) {
          quarterMap[point.x] = { quarter: point.x };
        }
        quarterMap[point.x][series.id] = point.y;
      });
    });

    return Object.values(quarterMap);
  };

  const rechartsData = convertToRechartsData(oceanFreightData);
  const seriesKeys = oceanFreightData?.map((series) => series.id) || [];

  // Extract colors from data with fallback colors
  const defaultColors = [
    "#1E0143",
    "#1021AD",
    "#592DFF",
    "#000C8E",
    "#52008E",
    "#901FB2",
    "#5C5CC9",
    "#9F91F3",
  ];

  const seriesColors =
    oceanFreightData?.reduce((acc, series, index) => {
      acc[series.id] =
        series.color || defaultColors[index % defaultColors.length];
      return acc;
    }, {}) || {};

  console.log("Series Colors:", seriesColors); // Debug: check colors

  const handleChange = (event) => {
    const values = event.target.value; // ["Houston", "Singapore"]
    setSelected(values);

    const result = locationData.flatMap((group) =>
      group.locations
        .filter((loc) => values.includes(loc))
        .map((loc) => ({
          region: group.region,
          location: loc,
        })),
    );

    setSelectedLocationDetails(result);
  };

  async function getListOfFuel() {
    const response = await axiosInstance.post(
      "company/analytics/fuels-listing",
      {},
    );
    const data = response?.data?.data ?? [];
    setFuel(data);
  }
  useEffect(() => {
    if (tab?.tabIndex !== 2) return;
    getListOfFuel();
  }, [tab]);

  async function getLocation(fuel) {
    const response = await axiosInstance.post(
      "company/analytics/region-listing",
      { fuel_name: fuel },
    );
    const data = response?.data?.data ?? [];
    setLocationData(data);
  }
  useEffect(() => {
    if (selectedFuel === "" || selected === null) return;
    getLocation(selectedFuel);
  }, [selectedFuel]);

  const buildChartData = (fuel, brent) => {
    const labels = [...new Set(fuel.map((i) => i.label))];
    const locations = [...new Set(fuel.map((i) => i.location))];

    return labels.map((label) => {
      const row = { quarter: label };

      locations.forEach((loc) => {
        const f = fuel.find((x) => x.label === label && x.location === loc);
        const b = brent.find((x) => x.label === label && x.location === loc);

        row[`Fuel_${loc}`] = f?.price || 0;
        row[`Brent_${loc}`] = b?.price || 0;
      });

      return row;
    });
  };

  async function fuelChartDetails() {
    const payload = {
      fuel_name: selectedFuel,
      pairs: selectedLocationDetails,
      range: range, // 1M or 3M or 6M or 1Y or ALL
    };
    const response = await axiosInstance.post(
      "company/analytics/fuel-price/chart",
      payload,
    );

    const data = response?.data?.data ?? [];
    // const chartData = data.fuel.map((fuelItem) => {
    //   const brentItem = data.brent.find((b) => b.label === fuelItem.label);

    //   return {
    //     quarter: fuelItem.label,
    //     Brent: brentItem?.price || 0,
    //     Fuel: fuelItem.price,
    //   };
    // });

    const chartData = buildChartData(data.fuel, data.brent);
    setData(chartData);

    // setData(chartData);
  }
  // const data = [
  //   { quarter: "Q1", Brunt: 5, Fuel: 1200 },
  //   { quarter: "Q2", Brunt: 8, Fuel: 1400 },
  //   { quarter: "Q3", Brunt: 12, Fuel: 1350 },
  //   { quarter: "Q4", Brunt: 10, Fuel: 1500 },
  // ];

  // const seriesConfig = [
  //   { key: "Fuel", axis: "left", color: "#ff6b6b", dashed: false },
  //   { key: "Brent", axis: "right", color: "#4dabf7", dashed: true },
  //   // { key: "Brent", axis: "right", stroke: "blue" },
  // ];

  // const filterData = (range) => {
  //   if (range === "1M") return data.slice(-4); // last 4 weeks
  //   if (range === "3M") return data.slice(-12);
  //   if (range === "6M") return data.slice(-24);
  //   if (range === "1Y") return data;
  // };

  // const chartData = filterData(range);

  useEffect(() => {
    if (range && selectedFuel && selectedLocationDetails?.length) {
      fuelChartDetails();
    }
  }, [selectedLocationDetails, selectedFuel, range]);

  const seriesConfig = [
    ...selectedLocationDetails.map((item, index) => ({
      key: `Fuel_${item.location}`,
      axis: "left",
      color: ["#4dabf7", "#1c7ed6", "#74c0fc"][index % 3],
      dashed: false,
    })),
    ...selectedLocationDetails.map((item, index) => ({
      key: `Brent_${item.location}`,
      axis: "right",
      color: ["#ff6b6b", "#e03131", "#ff8787"][index % 3],
      dashed: true,
    })),
  ];

  return (
    <>
      <Header />
      <ToastContainer position="top-right" />
      <Box
        sx={{
          background: "linear-gradient(90deg,#6d4bd3,#2b144f)",
          m: 0,
          textAlign: "center",
          marginTop: "67px",
          height: 80,
        }}
      >
        <p className="header-text-style">Market Intelligence</p>
      </Box>

      {/* Header */}
      <Box
        sx={{
          minHeight: tab?.tabIndex !== 2 ? "100vh" : "auto",
          bgcolor: "#f4f6fa",
          p: { xs: 1, sm: 2, md: 3 },
        }}
      >
        {
          <>
            {/* Tabs */}
            <Paper sx={{ mt: 0, bgcolor: "#2b0057", borderRadius: 2 }}>
              <Tabs
                value={tab?.tabIndex}
                onChange={(e, v) => updateTab(e, v)}
                variant={isMobile ? "scrollable" : "fullWidth"}
                scrollButtons="auto"
                textColor="inherit"
                sx={{
                  display: "flex",
                  //   width: "100vw",
                  justifyContent: "space-between",
                }}
                TabIndicatorProps={{
                  style: {
                    background: "#fff",
                  },
                }}
              >
                <Tab
                  label="Ocean Freight "
                  sx={tabStyle(tab?.tabIndex === 0)}
                />
                <Tab label="Tariff" sx={tabStyle(tab?.tabIndex === 1)} />
                <Tab label="Fuels" sx={tabStyle(tab?.tabIndex === 2)} />
              </Tabs>
            </Paper>
            {
              <>
                <Paper sx={{ mt: 2, p: 2, borderRadius: 2 }}>
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: "1fr",
                      sm: "1fr 1fr",
                      md: "repeat(4,1fr)",
                    }}
                    gap={2}
                  >
                    {tab?.tabIndex !== 2 ? (
                      <>
                        <MultiSelectFilter
                          label={tab?.tabList[0]?.name || ""}
                          isMultiple={tab?.tabList[0]?.multiSelect ?? true}
                          value={firstDropDown}
                          options={firstDropDownData ?? []}
                          onChange={setFirstDropDown}
                        />
                        <MultiSelectFilter
                          value={secondDropDown}
                          label={tab?.tabList[1]?.name || ""}
                          isMultiple={tab?.tabList[1]?.multiSelect ?? true}
                          options={secondDropDownData ?? []}
                          onChange={setSecondDropDown}
                        />
                        <MultiSelectFilter
                          value={thirdDropDown}
                          label={tab?.tabList[2]?.name || ""}
                          isMultiple={tab?.tabList[2]?.multiSelect ?? true}
                          options={thirdDropDownData}
                          onChange={setThirdDropDown}
                        />
                        <MultiSelectFilter
                          value={forthDropDown}
                          label={tab?.tabList[3]?.name || ""}
                          isMultiple={tab?.tabList[3]?.multiSelect ?? true}
                          options={forthDropDownData}
                          onChange={setForthDropDown}
                          onMetaChange={setCountryPortData}
                        />
                      </>
                    ) : (
                      <>
                        {/* <Box
                          display="grid"
                          gridTemplateColumns={{
                            xs: "1fr",
                            md: "80% 80%",
                            lg: "100% 100%",
                          }}
                          gap={2}
                          width="190%"
                        >
                          <Autocomplete
                            size="small"
                            fullWidth
                            options={Array.isArray(fuel) ? fuel : []}
                            getOptionLabel={(option) => option?.fuel_name || ""}
                            value={
                              Array.isArray(fuel)
                                ? fuel.find(
                                    (f) => f.fuel_name === selectedFuel,
                                  ) || null
                                : null
                            }
                            onChange={(e, newValue) => {
                              setSelected([]);
                              setSelectedLocationDetails([]);
                              setData([]);
                              setSelectedFuel(
                                newValue ? newValue.fuel_name : "",
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Fuel"
                              />
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option?.fuel_name === value?.fuel_name
                            }
                          />
                          <Select
                            multiple
                            value={selected}
                            onChange={handleChange}
                            input={<OutlinedInput size="small" />}
                            fullWidth
                            renderValue={(selected) => selected.join(", ")}
                            sx={{
                              "& .MuiSelect-select": {
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontSize: 13,
                                fontWeight: 600,
                              },
                            }}
                          >
                            {locationData.map((group) => [
                              <ListSubheader
                                key={group.region}
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: 14,
                                  padding: "-3px 0px",
                                }}
                              >
                                {group.region}
                              </ListSubheader>,

                              group.locations.map((option) => (
                                <MenuItem
                                  key={option}
                                  value={option}
                                  sx={{ fontSize: 12, padding: "0px 20px" }}
                                >
                                  <Checkbox
                                    checked={selected.includes(option)}
                                    size="small"
                                  />
                                  {option}
                                </MenuItem>
                              )),
                            ])}
                          </Select>
                        </Box> */}
                        <Box gridColumn="1 / -1">
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                              gap: 2,
                              width: "100%",
                            }}
                          >
                            <Autocomplete
                              size="small"
                              fullWidth
                              options={Array.isArray(fuel) ? fuel : []}
                              getOptionLabel={(option) =>
                                option?.fuel_name || ""
                              }
                              value={
                                Array.isArray(fuel)
                                  ? fuel.find(
                                      (f) => f.fuel_name === selectedFuel,
                                    ) || null
                                  : null
                              }
                              onChange={(e, newValue) => {
                                setSelected([]);
                                setSelectedLocationDetails([]);
                                setData([]);
                                setSelectedFuel(
                                  newValue ? newValue.fuel_name : "",
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select Fuel"
                                />
                              )}
                              isOptionEqualToValue={(option, value) =>
                                option?.fuel_name === value?.fuel_name
                              }
                            />

                            <Select
                              multiple
                              value={selected}
                              onChange={handleChange}
                              input={<OutlinedInput size="small" />}
                              fullWidth
                              renderValue={(selected) => selected.join(", ")}
                              sx={{
                                "& .MuiSelect-select": {
                                  display: "block",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  fontSize: 13,
                                  fontWeight: 600,
                                },
                              }}
                            >
                              {locationData.map((group) => [
                                <ListSubheader
                                  key={group.region}
                                  sx={{ fontWeight: 700, fontSize: 13 }}
                                >
                                  {group.region}
                                </ListSubheader>,

                                group.locations.map((option) => (
                                  <MenuItem
                                    key={option}
                                    value={option}
                                    sx={{ fontSize: 12, py: 0.5 }}
                                  >
                                    <Checkbox
                                      checked={selected.includes(option)}
                                      size="small"
                                    />
                                    {option}
                                  </MenuItem>
                                )),
                              ])}
                            </Select>
                          </Box>
                        </Box>
                      </>
                    )}
                  </Box>
                </Paper>
                <Box
                  display="grid"
                  gridTemplateColumns={{
                    xs: "1fr",
                    md: "2fr 1fr",
                  }}
                  gap={2}
                  mt={2}
                  //   sx={{ height: 160 }}
                >
                  {/* Chart */}
                  <Paper sx={{ p: 2, borderRadius: 2 }}>
                    <Typography
                      fontWeight={600}
                      fontSize={14}
                      mb={1}
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      {currentTab[tab?.tabIndex]}
                    </Typography>
                    <Box
                      // height={isMobile ? 260 : 320}\
                      sx={{
                        height: { xs: 260, sm: 300, md: 350 },
                      }}
                    >
                      {tab?.tabIndex !== 2 ? (
                        <>
                          {oceanFreightData?.length > 0 ? (
                            //   <ResponsiveLine
                            //   data={oceanFreightData ?? []}
                            //   margin={{
                            //     top: 20,
                            //     right: isMobile ? 20 : 80,
                            //     bottom: isMobile ? 40 : 50,
                            //     left: isMobile ? 40 : 60,
                            //   }}
                            //   xScale={{ type: "point" }}
                            //   pointSize={hasSinglePoint ? 10 : isMobile ? 4 : 6}
                            //   enableGridX={false}
                            //   enableGridY={false}
                            //   axisBottom={{
                            //     tickSize: 0,
                            //     tickPadding: 10,
                            //     legend:
                            //       tab?.tabName === "Tariff"
                            //         ? "Quarter"
                            //         : "Quarter",
                            //     legendOffset: 40,
                            //   }}
                            //   axisLeft={{
                            //     tickSize: 0,
                            //     tickPadding: 10,
                            //     format: (v) =>
                            //       tab?.tabName === "Tariff" ? `${v}%` : v,
                            //     legend:
                            //       tab?.tabName === "Tariff"
                            //         ? "Tariff"
                            //         : "Ocean Freight (USD Per MT)",
                            //     legendOffset: -45,
                            //   }}
                            //   yFormat={(v) =>
                            //     tab?.tabName === "Tariff" ? `${v}%` : v
                            //   }
                            //   colors={{ datum: "color" }}
                            //   yScale={{
                            //     type: "linear",
                            //     min: "auto",
                            //     max: "auto",
                            //     // stacked: true,
                            //     stacked: false,
                            //     reverse: false,
                            //   }}
                            //   pointColor={{ theme: "background" }}
                            //   pointBorderWidth={8}
                            //   pointBorderColor={{ from: "seriesColor" }}
                            //   pointLabelYOffset={-12}
                            //   enableTouchCrosshair={true}
                            //   useMesh={true}
                            //   enableSlices="x"
                            //   legends={
                            //     isMobile
                            //       ? []
                            //       : [
                            //           {
                            //             anchor: "bottom-right",
                            //             direction: "column",
                            //             translateY: 45,
                            //             itemWidth: isTablet ? 110 : 140,
                            //             itemHeight: 14,
                            //             symbolSize: 14,
                            //           },
                            //         ]
                            //   }
                            //   theme={{
                            //     tooltip: {
                            //       container: {
                            //         background: "#1E1E2D",
                            //         color: "#fff",
                            //         fontSize: 12,
                            //         width: "max-content",
                            //       },
                            //     },
                            //     axis: {
                            //       domain: {
                            //         line: {
                            //           stroke: "#000", // bottom axis line color
                            //           strokeWidth: 0.2, // thickness
                            //         },
                            //       },
                            //     },
                            //   }}
                            // />

                            <ResponsiveContainer width="100%" height="100%">
                              <LineChart
                                data={rechartsData}
                                // margin={{
                                //   top: 20,
                                //   // right: isMobile ? 20 : 30,
                                //   // bottom: isMobile ? 40 : 80,
                                //   left: isMobile ? 10 : 20,
                                // }}
                              >
                                <CartesianGrid
                                  strokeDasharray="0"
                                  stroke="#f0f0f0"
                                />
                                <XAxis
                                  dataKey="quarter"
                                  tick={{ fontSize: isMobile ? 10 : 12 }}
                                  label={{
                                    value: "Quarter",
                                    position: "insideBottom",
                                    offset: -10,
                                    style: {
                                      fontWeight: 600,
                                      fontSize: isMobile ? 11 : 12,
                                    },
                                  }}
                                />
                                <YAxis
                                  tick={{ fontSize: isMobile ? 10 : 12 }}
                                  tickFormatter={(v) =>
                                    tab?.tabName === "Tariff" ? `${v}%` : v
                                  }
                                  label={{
                                    value:
                                      tab?.tabName === "Tariff"
                                        ? "Tariff"
                                        : "Ocean Freight (USD Per MT)",
                                    angle: -90,
                                    position: "insideLeft",
                                    style: {
                                      textAnchor: "middle",
                                      fontWeight: 600,
                                      fontSize: isMobile ? 11 : 12,
                                    },
                                  }}
                                />
                                <Tooltip
                                  contentStyle={{
                                    background: "#1E1E2D",
                                    color: "#fff",
                                    fontSize: 12,
                                    borderRadius: 4,
                                    border: "none",
                                  }}
                                  formatter={(value) =>
                                    tab?.tabName === "Tariff"
                                      ? `${value}%`
                                      : value
                                  }
                                />
                                {!isMobile && (
                                  <Legend
                                    verticalAlign="bottom"
                                    align="center"
                                    wrapperStyle={{
                                      paddingTop: 20,
                                      fontSize: 12,
                                    }}
                                    iconType="circle"
                                    iconSize={10}
                                  />
                                )}
                                {seriesKeys.map((key) => (
                                  <Line
                                    key={key}
                                    type="monotone"
                                    dataKey={key}
                                    stroke={seriesColors[key]}
                                    strokeWidth={2}
                                    dot={{
                                      r: hasSinglePoint ? 5 : isMobile ? 3 : 4,
                                      fill: "#fff",
                                      strokeWidth: 2,
                                    }}
                                    activeDot={{ r: 6 }}
                                  />
                                ))}
                              </LineChart>
                            </ResponsiveContainer>
                          ) : (
                            <Box
                              sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#000000ff",
                                fontSize: 14,
                              }}
                            >
                              {/* No data available */}
                              {chartMessage}
                            </Box>
                          )}
                        </>
                      ) : (
                        <>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              // height: 350,
                              height: "100%",
                              minHeight: 260,
                            }}
                          >
                            {/* Time Range Filter */}
                            <div
                              style={{
                                position: "absolute",
                                top: -40,
                                right: 15,
                                display: "flex",
                                gap: 6,
                                zIndex: 10,
                              }}
                            >
                              {["1M", "3M", "6M", "1Y", "ALL"].map((r) => (
                                <button
                                  key={r}
                                  onClick={() => setRange(r)}
                                  style={{
                                    padding: "3px 8px",
                                    borderRadius: 4,
                                    fontSize: 12,
                                    border:
                                      range === r
                                        ? "1px solid #2563eb"
                                        : "1px solid #ccc",
                                    background:
                                      range === r ? "#2563eb" : "#fff",
                                    color: range === r ? "#fff" : "#000",
                                    cursor: "pointer",
                                  }}
                                >
                                  {r}
                                </button>
                              ))}
                            </div>

                            {/* Chart */}
                            {/* <ResponsiveContainer
                              width="100%"
                              height="100%"
                              // width="100%" height={350}
                            >
                              {data.length ? (
                                <LineChart data={data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="quarter" />

                                  {[
                                    ...new Set(seriesConfig.map((s) => s.axis)),
                                  ].map((axis) => (
                                    <YAxis
                                      key={axis}
                                      yAxisId={axis}
                                      orientation={
                                        axis === "right" ? "right" : "left"
                                      }
                                    />
                                  ))}

                                  <Tooltip />
                                  <Legend />

                                  {seriesConfig.map((s) => (
                                    <Line
                                      key={s.key}
                                      yAxisId={s.axis}
                                      type="monotone"
                                      dataKey={s.key}
                                      stroke={s.color}
                                      strokeDasharray={s.dashed ? "5 5" : "0"}
                                      strokeWidth={2}
                                    />
                                  ))}
                                </LineChart>
                              ) : (
                                <Box
                                  sx={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: { xs: 12, sm: 14 },
                                    color: "#666",
                                  }}
                                >
                                  No Record found
                                </Box>
                              )}
                            </ResponsiveContainer> */}

                            <ResponsiveContainer width="100%" height="100%">
                              {data.length ? (
                                <LineChart data={data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis
                                    dataKey="quarter"
                                    label={{
                                      value: "Time period",
                                      position: "insideBottom",
                                      offset: -10,
                                      style: { fontWeight: 600 },
                                    }}
                                  />

                                  {[
                                    ...new Set(seriesConfig.map((s) => s.axis)),
                                  ].map((axis) => (
                                    <YAxis
                                      key={axis}
                                      yAxisId={axis}
                                      label={{
                                        value:
                                          axis === "right"
                                            ? "Brent (USD/BBL) "
                                            : "Fuel (USD/MT) ", // dynamic text
                                        angle: axis !== "right" ? -90 : -270,
                                        position:
                                          axis === "right"
                                            ? "insideRight"
                                            : "insideLeft",
                                        style: {
                                          textAnchor: "middle",
                                          fontWeight: 600,
                                        },
                                      }}
                                      orientation={
                                        axis === "right" ? "right" : "left"
                                      }
                                    />
                                  ))}

                                  <Tooltip />
                                  <Legend
                                    // verticalAlign="bottom"
                                    // align="right"
                                    wrapperStyle={{
                                      paddingTop: 10,
                                      // fontSize: 14,
                                    }}
                                  />

                                  {seriesConfig.map((s) => (
                                    <Line
                                      key={s.key}
                                      yAxisId={s.axis}
                                      type="monotone"
                                      dataKey={s.key}
                                      stroke={s.color}
                                      strokeDasharray={s.dashed ? "5 5" : "0"}
                                      strokeWidth={2}
                                    />
                                  ))}
                                </LineChart>
                              ) : (
                                <Box
                                  sx={{
                                    width: "100vh",
                                    height: "50vh",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: { xs: 12, sm: 14 },
                                    color: "#666",
                                  }}
                                >
                                  No Record found
                                </Box>
                              )}
                            </ResponsiveContainer>
                          </div>
                        </>
                      )}
                    </Box>
                  </Paper>
                  {/* News */}
                  <Paper
                    sx={{
                      borderRadius: 2,
                      height: { xs: "auto", md: "64.5vh" },
                      maxHeight: { md: "64.5vh" },
                      overflow: "auto",
                    }}
                  >
                    {newsList.map((item) => (
                      <NewsCard
                        key={item.id}
                        image={item.image}
                        date={item.date}
                        title={item.title}
                        tabName={tab?.tabName}
                        originCountries={
                          tab?.tabIndex == 0
                            ? thirdDropDown
                            : tab?.tabIndex == 1
                              ? forthDropDown
                              : selectedLocationDetails
                        }
                        destinationCountry={
                          tab?.tabIndex == 0
                            ? firstDropDown
                            : tab?.tabIndex == 1
                              ? thirdDropDown
                              : selectedLocationDetails
                        }
                      />
                    ))}
                  </Paper>
                </Box>
              </>
            }
          </>
        }
      </Box>

      {/* Workspace Analytics */}

      <Box
        sx={{
          background: "linear-gradient(90deg,#6d4bd3,#2b144f)",
          m: 0,
          textAlign: "center",
          //   marginTop: "67px",
          height: 80,
        }}
      >
        <p className="header-text-style">Workspace Analytics</p>
      </Box>

      <Box className="market-analytics-body">
        <WorkspaceAnalytics />
      </Box>
    </>
  );
}

const tabStyle = (active) => ({
  color: active ? "#2b0057" : "#fff",
  bgcolor: active ? "#fff" : "transparent",
  borderRadius: 1,
  m: 1,
  textTransform: "none",
  fontWeight: 500,
  flex: 1,
  textAlign: "center",
});
